// Iter209dn — Flusso demo centralizzato.
// Chiama POST /auth/demo-login, salva token + flag demo in localStorage,
// e porta l'utente alla dashboard. Riutilizzato da:
//   - Mega-menu "Esplora demo" (PublicLayout.jsx)
//   - CTA "Esplora" nella hero della Landing (Landing.jsx)
export async function startDemo() {
  try {
    const { api } = await import("@/lib/api");
    const r = await api.post("/auth/demo-login");
    localStorage.setItem("ht_token", r.data.access_token);
    localStorage.setItem("ht_user", JSON.stringify(r.data.user));
    localStorage.setItem("ht_demo_mode", "1");
    window.location.href = "/dashboard";
  } catch {
    alert("Demo non disponibile");
  }
}
